import { useState, useCallback } from 'react'

const TOKEN_KEY = 'whimer_jwt'

interface UseAuthReturn {
  isAuthenticated: boolean
  token: string | null
  isLoading: boolean
  login: (jwt: string) => void
  logout: () => void
}

export function useAuth(): UseAuthReturn {
  const [token, setToken] = useState<string | null>(() => localStorage.getItem(TOKEN_KEY))
  const [isLoading] = useState(false)

  const login = useCallback((jwt: string) => {
    localStorage.setItem(TOKEN_KEY, jwt)
    setToken(jwt)
  }, [])

  const logout = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY)
    setToken(null)
  }, [])

  return { isAuthenticated: !!token, token, isLoading, login, logout }
}
